export enum LocalizedTextLanguages {
  RU = 'RU',
  KZ = 'KZ',
  EN = 'EN',
}

export enum InputTypes {
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
}

export enum ValidationTypes {
  REQUIRED = 'REQUIRED',
  MIN = 'MIN',
  MAX = 'MAX',
  DECIMAL_PRECISION = 'DECIMAL_PRECISION',
  RANGE = 'RANGE',
  INTEGER_ONLY = 'INTEGER_ONLY',
}

export enum InputModes {
  FREE = 'FREE',
  CHECKBOX = 'CHECKBOX',
  RESTRICTED = 'RESTRICTED',
}
